
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[id]",
      function () {
        return require("private-next-pages/products/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[id]"])
      });
    }
  